import { Link } from "react-router-dom";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import FileInput from "../../../components/input/FileInput";

import itau from "../../../assets/banks/logo-itau.png";
import caixa from "../../../assets/banks/logo-caixa.png";
import safra from "../../../assets/banks/banco-safra.png";
import wallet from "../../../assets/banks/logo-wallet.png";
import sicoob from "../../../assets/banks/banco-sicoob.png";
import sicredi from "../../../assets/banks/logo-sicredi.png";
import bradesco from "../../../assets/banks/logo-bradesco.png";
import santander from "../../../assets/banks/logo-santander.png";
import brazilBank from "../../../assets/banks/banco-do-brasil.png";

import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { postInstallmentReturn } from "../../../services/Financial/Return/postInstallmentReturn";
import { toast } from "react-toastify";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";
import { postReturnPayment } from "../../../services/Financial/Return/postReturnPayment";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

const Returns = () => {
  usePermission("121"); //Visualizar Retornos

  const { permissions } = useAppContext()
  const items = [
    {
      template: () => (
        <Link to={"/financial/returns"} className="p-breadcrumb-link">
          Retornos
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  function MovCode(code) {
    const codes = {
      "02": "Entrada Confirmada",
      "03": "Entrada Rejeitada",
      "04": "Transferência de Carteira/Entrada",
      "05": "Transferência de Carteira/Baixa",
      "06": "Liquidação",
      "07": "Confirmação do Recebimento da Instrução de Desconto",
      "08": "Confirmação do Recebimento do Cancelamento do Desconto",
      "09": "Baixa",
      11: "Títulos em Carteira (Em Ser)",
      12: "Confirmação Recebimento Instrução de Abatimento",
      13: "Confirmação Recebimento Instrução de Cancelamento Abatimento",
      14: "Confirmação Recebimento Instrução Alteração de Vencimento",
      15: "Franco de Pagamento",
      17: "Liquidação Após Baixa ou Liquidação Título Não Registrado",
      19: "Confirmação Recebimento Instrução de Protesto",
      20: "Confirmação Recebimento Instrução de Sustação/Cancelamento de Protesto",
      23: "Remessa a Cartório (Aponte em Cartório)",
      24: "Retirada de Cartório e Manutenção em Carteira",
      25: "Protestado e Baixado (Baixa por Ter Sido Protestado)",
      26: "Instrução Rejeitada",
      27: "Confirmação do Pedido de Alteração de Outros Dados",
      28: "Débito de Tarifas/Custas",
      29: "Ocorrências do Pagador",
    };

    return codes[code] || "Código de movimento não reconhecido";
  }

  function NameBank(name) {
    const names = {
      "001": "Banco do Brasil",
      "033": "Banco Santander",
      748: "Banco Sicredi",
      422: "Banco Safra",
      341: "Banco Itaú",
      104: "Banco Caixa",
      756: "Banco Sicoob",
      237: "Banco Bradesco",
    };

    return names[name] || "Banco não reconhecido";
  }

  function formatDateReturn(dateString) {
    // Extrair o dia, mês e ano da string
    const year = dateString.substring(4);
    const month = dateString.substring(2, 4);
    const day = dateString.substring(0, 2);

    // Criar uma nova data no formato desejado
    var formattedDate = `${year}-${month}-${day}`;
    if (formattedDate == "--") {
      formattedDate = "";
    }

    return formattedDate;
  }

  const transformObjects = (objs) => {
    return {
      installments: objs.map((obj) => ({
        id: obj.id,
        payment_value: parseFloat(obj.payment_value),
        addition_value: obj.addition,
        payment_value_discount: obj.discount,
        payment_date: obj.due_payment,
      })),
    };
  };

  const columns = [
    { field: "id", header: "Nº Boleto" },
    {
      field: "cod_mov",
      header: "Cód. Movimento",
      body: (rowData) => MovCode(rowData.cod_mov),
    }, //
    { field: "enterprise", header: "Empreen." },
    { field: "block", header: "Quadra" },
    { field: "land", header: "Lote" },
    { field: "client", header: "Pagador" },
    {
      field: "due_date",
      header: "Vencimento",
      body: (rowData) => formatDate(rowData.due_date),
    },
    {
      field: "due_payment",
      header: "Data Pagamento",
      body: (rowData) => formatDate(rowData.due_payment),
    },
    {
      field: "value",
      header: "Valor",
      body: (rowData) => formatCurrency(rowData.value),
    },
    {
      field: "discount",
      header: "Desconto",
      body: (rowData) => formatCurrency(rowData.discount),
    }, //
    {
      field: "addition",
      header: "Acrés.",
      body: (rowData) => formatCurrency(rowData.addition),
    }, //
    {
      field: "payment_value",
      header: "Valor Pago",
      body: (rowData) => formatCurrency(rowData.payment_value),
    }, //
  ];

  const rowClassName = (rowData) => {
    return rowData.status === 1 ? "bg-teal-200" : "";
  };

  const [selectedFile, setSelectedFile] = useState("");
  const [readTextFile, setReadTextFile] = useState("");
  const [bank, setBank] = useState("");
  const [cnab, setCnab] = useState("");
  const [codBank, setCodBank] = useState("");
  const [dataTableValue, setDataTableValue] = useState([]);
  const [itemsSelected, setItemsSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [onRemove, setOnRemove] = useState(false);
  const [nameBank, setNameBank] = useState([]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    const updatedRows = filteredRows.map((row) => {
      // Verifica se a linha possui o campo check_id antes de atualizar o estado
      if (row.check_id) {
        return { ...row, selected: newSelectAll };
      } else {
        return row; // Retorna a linha sem alterações se não houver checkbox
      }
    });
    if (newSelectAll) {
      setItemsSelected(updatedRows);
    } else {
      setItemsSelected([]);
    }
  };
  const handleRowSelect = (rowData) => {
    // Verificar se a linha já está selecionada
    const isSelected = itemsSelected.some((row) => row.id === rowData.id);
    // Criar uma cópia do estado atual de selectedRows
    let updatedSelectedRows = [...itemsSelected];
    // Se a linha já estiver selecionada, remova-a do estado selectedRows
    if (isSelected) {
      updatedSelectedRows = updatedSelectedRows.filter(
        (row) => row.id !== rowData.id
      );
    } else {
      updatedSelectedRows.push(rowData);
    }
    //    console.log(updatedSelectedRows.length);
    //    console.log(filteredRows.length);

    if (updatedSelectedRows.length == filteredRows.length) {
      handleSelectAll();
    } else {
      setSelectAll(false);
    }
    // Atualizar o estado selectedRows com a nova lista atualizada
    setItemsSelected(updatedSelectedRows);
  };
  const handlePaymentParcel = () => {
    const notification = toast.loading(
      "Por favor aguarde, a baixa está sendo realizada..."
    );
    try {
      const ObjTransformed = transformObjects(itemsSelected);
      postReturnPayment(ObjTransformed);
      toast.update(notification, {
        render: "Baixa realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      if (notification) {
        toast.update(notification, {
          render: "Não foi possível realizar a baixa de Parcelas",
          autoClose: 1000,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      }
    }
    setDataTableValue([]);
    setItemsSelected([]);
    setReadTextFile("");
    setSelectedFile("");
    setSelectAll(false);
    setOnRemove(true);
  };

  const onConfirmButton = (file) => {
    setDataTableValue([]);
    setItemsSelected([]);
    if (readTextFile && readTextFile !== "") {
      const lines = readTextFile.split("\n");
      // Variáveis para armazenar os resultados
      const contentAtPosition = [];
      const contentAtPositionPaymentValue = [];
      const contentAtPositionPaymentDate = [];
      const contentAtPositionValue = [];
      const contentAtPositionDate = [];
      const contentAtPositionMovCode = [];
      const contentAtPositionAddition = [];
      const contentAtPositionDiscount = [];
      var startPositionId, //Id da Parcela
        endPositionId, //Id da Parcela
        startPositionPaymentValue, //Valor Pago da Parcela
        endPositionPaymentValue, //Valor Pago da Parcela
        startPositionValue, //Valor da Parcela
        endPositionValue, //Valor da Parcela
        startPositionDate, //Data de Pagamento da Parcela
        endPositionDate, //Data de Pagamento da Parcela
        startPositionPaymentDate, //Data de Pagamento da Parcela
        endPositionPaymentDate, //Data de Pagamento da Parcela
        startPositionMovCode, //Código de Movimento do Retorno
        endPositionMovCode, //Código de Movimento do Retorno
        startPositionAddition, //Acréscimo da Parcela
        endPositionAddition, //Acréscimo da Parcela
        startPositionDiscount, //Desconto da Parcela
        endPositionDiscount; //Desconto da Parcela

      if (cnab >= 400) {
        switch (codBank) {
          case "033":
            startPositionId = 77;
            endPositionId = 79;
            break;
          case "422":
            startPositionId = 77;
            endPositionId = 79;
            break;
          case "341":
            startPositionId = 127;
            endPositionId = 135;
            break;
          case "104":
            startPositionId = 77;
            endPositionId = 79;
            break;
          case "237":
            startPositionId = 77;
            endPositionId = 79;

            startPositionMovCode = 16;
            endPositionMovCode = 17;

            startPositionAddition = 18;
            endPositionAddition = 32;

            startPositionDiscount = 33;
            endPositionDiscount = 47;

            startPositionValue = 82;
            endPositionValue = 96;

            startPositionDate = 74;
            endPositionDate = 81;

            startPositionPaymentValue = 78;
            endPositionPaymentValue = 92;

            startPositionPaymentDate = 138;
            endPositionPaymentDate = 145;

            break;
        }
      } else {
        switch (codBank) {
          case "001":
            startPositionId = 45;
            endPositionId = 54;

            break;
          case "033":
            startPositionId = 41;
            endPositionId = 52;

            break;
          case "237":
            startPositionId = 43;
            endPositionId = 56;

            break;
          case "341":
            startPositionId = 41;
            endPositionId = 48;

            break;
          case "104":
            startPositionId = 42;
            endPositionId = 56;

            break;

          case "756":
            startPositionId = 37;
            endPositionId = 46;

            break;

          case "422":
            startPositionId = 40;
            endPositionId = 48;
            break;
        }

        startPositionMovCode = 16;
        endPositionMovCode = 17;

        startPositionAddition = 18;
        endPositionAddition = 32;

        startPositionDiscount = 33;
        endPositionDiscount = 47;

        startPositionValue = 82;
        endPositionValue = 96;

        startPositionDate = 74;
        endPositionDate = 81;

        startPositionPaymentValue = 78;
        endPositionPaymentValue = 92;

        startPositionPaymentDate = 138;
        endPositionPaymentDate = 145;
      }
      lines.forEach((line) => {
        // Verificar se a linha tem o comprimento mínimo para ter a posição desejada
        if (line.length >= 14) {
          // Verificar se o caractere na posição 14 é "T"
          if (line.charAt(13) === "T") {
            // Extrair o conteúdo da posição desejada
            //            // console.log(line);

            const contentValue = line
              .substring(startPositionValue - 1, endPositionValue)
              .replace(/^\s*0+/, "")
              .trim();

            const formattedValue =
              isNaN(contentValue) || contentValue === ""
                ? 0
                : (parseFloat(contentValue) / 100).toFixed(2);

            const contentDate = line
              .substring(startPositionDate - 1, endPositionDate)
              .replace(/^\s*0+/, "")
              .trim();

            const formattedDate = formatDateReturn(contentDate);
            const content = line
              .substring(startPositionId - 1, endPositionId)
              .replace(/^\s*0+/, "")
              .trim();

            // Adicionar o conteúdo à lista de resultados
            contentAtPosition.push(content);
            contentAtPositionValue.push(formattedValue);
            contentAtPositionDate.push(formattedDate);
          }
          if (line.charAt(13) === "U") {
            const contentPaymentDate = line
              .substring(startPositionPaymentDate - 1, endPositionPaymentDate)
              .replace(/^\s*0+/, "")
              .trim();
            const formattedDate = formatDateReturn(contentPaymentDate);

            const contentMovCode = line
              .substring(startPositionMovCode - 1, endPositionMovCode)
              .trim();

            const contentAddition = line
              .substring(startPositionAddition - 1, endPositionAddition)
              .replace(/^\s*0+/, "")
              .trim();

            const formattedValueAddition =
              isNaN(contentAddition) || contentAddition === ""
                ? 0
                : (parseFloat(contentAddition) / 100).toFixed(2);

            const contentDiscount = line
              .substring(startPositionDiscount - 1, endPositionDiscount)
              .replace(/^\s*0+/, "")
              .trim();

            const formattedValueDiscount =
              isNaN(contentDiscount) || contentDiscount === ""
                ? 0
                : (parseFloat(contentDiscount) / 100).toFixed(2);

            const contentPaymentValue = line
              .substring(startPositionPaymentValue - 1, endPositionPaymentValue)
              .replace(/^\s*0+/, "")
              .trim();

            const formattedValue =
              isNaN(contentPaymentValue) || contentPaymentValue === ""
                ? 0
                : (parseFloat(contentPaymentValue) / 100).toFixed(2);

            contentAtPositionMovCode.push(contentMovCode);
            contentAtPositionPaymentValue.push(formattedValue);
            contentAtPositionPaymentDate.push(formattedDate);
            contentAtPositionAddition.push(formattedValueAddition);
            contentAtPositionDiscount.push(formattedValueDiscount);
          }
        }
      });

      const installmentsIds = contentAtPosition.map(Number);
      const obj = {
        installments_ids: installmentsIds,
      };
      const notification = toast.loading(
        "Por favor, arquivo sendo analisado..."
      );
      postInstallmentReturn(obj)
        .then((response) => {
          if (response.length === 0) {
            toast.update(notification, {
              render: "Não existem parcelas do Retorno no Sistema!",
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "warning",
              isLoading: false,
            });
            return; // Encerra a execução da função
          }

          const findObjectById = (id) => {
            return response.find((obj) => obj.id === parseInt(id));
          };
          const replicatedObjects = [];
          contentAtPosition.forEach((id, index) => {
            const foundObject = findObjectById(id);
            if (foundObject) {
              replicatedObjects.push({
                ...foundObject,
                value: contentAtPositionValue[index],
                due_date: contentAtPositionDate[index],
                due_payment: contentAtPositionPaymentDate[index],
                payment_value: contentAtPositionPaymentValue[index],
                cod_mov: contentAtPositionMovCode[index],
                addition: contentAtPositionAddition[index],
                discount: contentAtPositionDiscount[index],
              });
            } else {
              // Se não houver objeto correspondente, adiciona um objeto vazio com as propriedades esperadas
              replicatedObjects.push({
                id: "",
                enterprise: "",
                land: "",
                block: "",
                client: "",
                sequence_number: "",
                description: "",
                value: contentAtPositionValue[index],
                due_date: contentAtPositionDate[index],
                due_payment: contentAtPositionPaymentDate[index],
                payment_value: contentAtPositionPaymentValue[index],
                cod_mov: contentAtPositionMovCode[index],
                addition: contentAtPositionAddition[index],
                discount: contentAtPositionDiscount[index],
              });
            }
          });

          const newArray = replicatedObjects.filter((obj) => obj.id !== "");

          //          // console.log(newArray);
          setDataTableValue(newArray);
          toast.update(notification, {
            render: "Arquivo Analisado!",
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        })
        .catch((error) => {
          toast.update(notification, {
            render: "Não foi possível encontrar parcelas no arquivo!",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
          console.error(error);
        });
    }
  };

  const sumProperty = (array, prop) => {
    if (!Array.isArray(array)) {
      return 0;
    }

    return array.reduce((total, item) => {
      const value = parseFloat(item[prop]);
      return total + (isNaN(value) ? 0 : value);
    }, 0);
  };
  const totalValue = sumProperty(dataTableValue, "value");
  const totalPaid = sumProperty(dataTableValue, "payment_value");
  const totalDiscount = sumProperty(dataTableValue, "discount");
  const totalAddition = sumProperty(dataTableValue, "addition");

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={9}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalValue)} />
        <Column footer={formatCurrency(totalDiscount)} />
        <Column footer={formatCurrency(totalAddition)} />
        <Column footer={formatCurrency(totalPaid)} />
      </Row>
    </ColumnGroup>
  );

  useEffect(() => {
    var startPosition, endPosition;
    setDataTableValue([]);
    setItemsSelected([]);
    if (readTextFile && readTextFile !== "") {
      // Extrai apenas a primeira linha do arquivo
      const firstLine = readTextFile.split("\n")[0];
      const lineSize = firstLine.length;

      // const cnab = firstLine.length;

      if (lineSize >= 400) {
        setCnab(400);
        startPosition = 77; // Coluna inicial
        endPosition = 79; // Coluna final
      } else {
        setCnab(240);
        startPosition = 1; // Coluna inicial
        endPosition = 3; // Coluna final
      }

      const contentAtPosition = firstLine.substring(
        startPosition - 1,
        endPosition
      );

      setCodBank(contentAtPosition);
      setNameBank(NameBank(contentAtPosition));

      switch (contentAtPosition) {
        case "999":
          setBank(wallet);

          break;
        case "001":
          setBank(brazilBank);

          break;
        case "033":
          setBank(santander);

          break;
        case "748":
          setBank(sicredi);

          break;
        case "422":
          setBank(safra);

          break;
        case "341":
          setBank(itau);

          break;
        case "104":
          setBank(caixa);

          break;
        case "756":
          setBank(sicoob);

          break;
        case "237":
          setBank(bradesco);

          break;
      }
    }
  }, [readTextFile]);

  const filteredRows = [];
  return (
    <>
      <div className="col-md-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel>
        <FileInput
          isMultiple={false}
          typeFile=".txt,.ret,.mov"
          setSelectedFile={setSelectedFile}
          setReadTextFile={setReadTextFile}
          readTextFile={readTextFile}
          onConfirmButton={onConfirmButton}
          removeFile={onRemove}
          setRemoveFile={setOnRemove}
          bank={bank}
          buttonConfirm={true}
          doc="Arquivo de Retorno"
          icon="fa-rotate-left"
          title="Retornos"
        />
      </Panel>
      {dataTableValue.length > 0 && (
        <>
          <Panel
            mainCss="mt-4"
            title={`${nameBank} CNAB ${cnab}`}
            button={
              permissions && permissions.includes("122") && ( //Baixar Parcelas via Retorno
                <div className="text-end">
                  <Button
                    rounded
                    disabled={itemsSelected?.length === 0}
                    label="Baixar Parcelas"
                    icon="fa fa-download"
                    onClick={() => handlePaymentParcel()}
                    className="p-inputtext-sm me-2 m-auto w-100"
                  />
                </div>
              )
            }
          >
            <div className="row justify-content-end pb-3"></div>
            <div style={{ marginTop: "20px" }}>
              <DataTable
                stripedRows
                sortMode="multiple"
                selectionMode="multiple"
                value={dataTableValue}
                rowClassName={rowClassName}
                totalRecords={dataTableValue}
                footerColumnGroup={footerGroup}
                rows={100}
                scrollable
                scrollHeight="500px"
                sortableColumns={false}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{
                  minWidth: "1rem",
                  fontSize: "0.8rem",
                  border: "0.8rem",
                }}
              >
                <Column
                  field="check_id"
                  header={
                    <Checkbox onChange={handleSelectAll} checked={selectAll} />
                  }
                  body={(rowData) => {
                    if (
                      (rowData.cod_mov == "06" || rowData.cod_mov == "17") &&
                      rowData.status == 0
                    ) {
                      const index = filteredRows.findIndex(
                        (row) => row.id === rowData.id
                      );
                      if (index === -1) {
                        filteredRows.push(rowData);
                      }

                      return (
                        <Checkbox
                          checked={itemsSelected.some(
                            (row) => row.id === rowData.id
                          )}
                          onChange={() => handleRowSelect(rowData)}
                        />
                      );
                    } else {
                      return null;
                    }
                  }}
                />
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={col.body}
                  />
                ))}
              </DataTable>
            </div>
          </Panel>
        </>
      )}
    </>
  );
};

export default Returns;
